<template>
  <div>
    <div class="table">
      <!--=========查询模块================-->
      <div class="container">
        <div class="handle-box">
          <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="130px">
            <!-- <el-row v-if="puMulti == true">
              <el-col>
                <el-form-item :label="$t('sys.userList.userName')" prop="name">
                  <el-input class="handle-input" v-model="transferTo"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="Level1 Category" prop="categoryLevel1Code">
                  <ic-select disabled table="BASE" filterable field="CATEGORY_LEVEL1" clearable @change="queryCondition.categoryLevel2Code=null,queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel1Code"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Level2 Category" prop="categoryLevel2Code">
                  <ic-select table="BASE" filterable :field="queryCondition.categoryLevel1Code" clearable @change="queryCondition.categoryLevel3Code=null" v-model="queryCondition.categoryLevel2Code"></ic-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Level3 Category" prop="categoryLevel3code">
                  <ic-select :table="queryCondition.categoryLevel1Code" filterable :field="queryCondition.categoryLevel2Code" clearable v-model="queryCondition.categoryLevel3Code"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item :label="$t('base.fiveBitCode.title')" prop="fiveBitCode">
                  <el-input class="handle-input" v-model.trim="queryCondition.fiveBitCode" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('base.fiveBitCode.name')" prop="fiveBitCodeName">
                  <el-input class="handle-input" v-model="queryCondition.fiveBitCodeName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="产品描述" prop="describe">
                  <el-input class="handle-input" v-model="queryCondition.describe" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
              <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>
              <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
              <el-button type="primary" v-if="puMulti == true" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
            </el-row>
          </el-form>
        </div>
        <!--=========查询模块END================-->
        <!--=========用户信息数据列表================-->
        <el-table :data="tableData" ref="pickUserTable" row-key="fiveBitCode" border highlight-current-row max-height='350' @selection-change="selectionChange">
          <el-table-column v-if="puMulti == true" :reserve-selection="true" prop="fiveBitCode" type="selection" width="55" align="center" />
          <el-table-column v-if="!puMulti" prop="fiveBitCode" :label="$t('common.select')" width="50" align="center">
            <template slot-scope="scope">
              <!-- <el-radio v-model="selectDataAll" :label="scope.row.fiveBitCode">{{scope.row.fiveBitCode}}</el-radio> -->
              <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.fiveBitCode">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="categoryLevel1Name" label="Category Level1 Name" min-width="150"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="categoryLevel2Name" label="Category Level2 Name" min-width="150"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="categoryLevel3Name" label="Category Level3 Name" min-width="150"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="fiveBitCode" :label="$t('base.fiveBitCode.title')" min-width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="goToDetail(scope.row)">{{scope.row.fiveBitCode}}</el-button>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="fiveBitCodeName" :label="$t('base.fiveBitCode.name')" min-width="150"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="describe" label="产品描述" min-width="150"></el-table-column>
        </el-table>
        <div class="pagination">
          <!--===分页组件===-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
        </div>
      </div>
      <!--=========用户信息数据列表END================-->
    </div>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import IcSelect from "@/components/common/icSelect";
import dataTableUtils from "@/utils/dataTableUtils";
import fiveBitCode from "@/api/base-data/fiveBitCode";
import { disable } from "@/api/base-data/supplier";

export default {
  name: "pickupFiveBitCode",
  components: { IcSelect },
  props: {
    value: String,
    title: String,
    multi: Boolean,
    placeholder: String,
    selectDatas: Array,
    disabled: Array
  },
  extends: dataTableUtils,
  data() {
    return {
      radioVal: null,
      puMulti: this.multi,
      puPlaceholder: this.placeholder,
      tableData: [],
      selectedId: this.value,
      selectDataAll: this.multi
        ? {
          defaultData: commonFun.convertToArray(this.value),
          pageDatas: []
        }
        : this.value,
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fiveBitCode: '',
        fiveBitCodeName: '',
        categoryLevel1Code: '10',
        categoryLevel2Code: '',
        categoryLevel3Code: '',
        isEnable: 'Y',
        describe:"",
      },
      showDialog: false,
      notSelRoles: [],
      selectRows: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false
    };
  },
  created() {
    this.queryData(1);
  },
  computed: {
    getSelectedData() {
      if (this.multi) {
        let selectedData = [];
        let defaultData = this.selectDataAll.defaultData;
        if (commonFun.isNotEmpty(defaultData)) {
          selectedData.push(...defaultData);
        }
        let pageDatas = this.selectDataAll.pageDatas;
        for (let pageData of pageDatas.values()) {
          if (commonFun.isNotEmpty(pageData)) {
            selectedData.push(...pageData);
          }
        }
        return selectedData;
      } else {
        return this.selectDataAll;
      }
    },
    transferTo() {
      if (commonFun.isEmpty(this.getSelectedData)) {
        return null;
      }
      if (this.puMulti) {
        return this.getSelectedData
          .map(fiveBitCode => fiveBitCode.fiveBitCodeName)
          .join(";");
      } else {
        return this.selectDataAll.fiveBitCodeName;
      }
    }
  },
  watch: {
    value(newVal) {
      this.selectDataAll = this.multi
        ? {
          defaultData: commonFun.convertToArray(newVal),
          pageDatas: []
        }
        : newVal;
    }
  },
  methods: {
    goToDetail(row) {
      console.log("🚀 ~ file: templateName.vue ~ line 140 ~ goToDetail ~ row", row)
      const host = window.location.href.split("#")[0];
      console.log('111', host);
      var url = `${host}#/material-master-data/?fiveBitCode=${row.fiveBitCode}`;
      console.log('url', url);
      window.open(url, '_blank')
    },
    toggleSelection() {
      this.$refs.pickUserTable.clearSelection();
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRows = [];
      this.selectRows = row;
    },
    queryData(val) {
      var that = this;
      if (undefined != val) {
        that.queryCondition.pageNum = 1;
      }
      fiveBitCode.query(that.queryCondition).then(res => {
        that.tableData = res.data.records;
        that.totalCount = res.data.total;
      });
    },
    pickUp() {
      console.log(this.selectRows)
      this.$emit("pickup", this.selectRows);
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryCondition.fiveBitCode = ''
      this.queryCondition.fiveBitCodeName = ''
      this.queryCondition.categoryLevel1Code = '10'
      this.queryCondition.categoryLevel2Code = ''
      this.queryCondition.categoryLevel3Code = ''
      this.queryCondition.isEnable = 'Y'
      this.queryCondition.describe =''
      this.radioVal = ''
      this.$refs.pickUserTable.clearSelection();
      this.queryData();
    },
    selectionChange(rows) {
      let that = this
      this.selectRows = [];
      if (rows) {
        rows.forEach(val => {
          that.selectRows.push(val);
        });
      }
    }
  }
};
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
.el-table {
  margin-top: 10px;
}
</style>
